import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Pergunta {
  _id;
  fase;
  pergunta;
  type;
  code;
  options;
  attributes;
  order;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {Number} data.fase
   * @param {String} data.pergunta
   * @param {any} data.type
   * @param {any} data.code
   * @param {any} data.options
   * @param {any} data.attributes
   * @param {any} data.order
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.perguntas.filter(
      x =>
        String(x.code) === String(this.code) ||
        String(x.id) === String(this.id) ||
        (String(x.fase_id) === String(this.fase_id) &&
          String(x.order) === String(this.order)),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'perguntas');
    return db.perguntas.put(this);
  }

  static describe = () =>
    '++_id, fase, pergunta, type, code, options, attributes, order, createdAt, updatedAt, deletedAt';
}
